<template lang="">
  <div class="card">
    <div class="card-body">
      <b-row>
        <b-col lg="4" class="card__container">
          <div class="card__box card__box--do">
            <div class="card__icon"><i class="fas fa-chart-line"></i></div>
            <div class="card__content">
              <div>Tổng doanh thu</div>
              <div class="card__money">550 Tr</div>
            </div>
          </div>
        </b-col>
        <b-col lg="4" class="card__container">
          <div class="card__box card__box--xanh">
            <div class="card__icon"><i class="fas fa-hand-holding-usd"></i></div>
            <div class="card__content">
              <div>Doanh thu tháng này</div>
              <div class="card__money">150 Tr</div>
            </div>
          </div>
        </b-col>
        <b-col lg="4" class="card__container">
          <div class="card__box card__box--vang">
            <div class="card__icon"><i class="fas fa-paper-plane"></i></div>
            <div class="card__content">
              <div>Chi phí</div>
              <div class="card__money">30 Tr</div>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
.card {
  &__container {
    padding: 10px;
  }
  &__box {
    min-height: 200px;
    border-radius: 5px;

    display: flex;
    align-items: center;
    &--do {
      background: #f857a6; /* fallback for old browsers */
      background: -webkit-linear-gradient(to right, #ff5858, #f857a6); /* Chrome 10-25, Safari 5.1-6 */
      background: linear-gradient(to right, #ff5858, #f857a6); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    }
    &--xanh {
      background: #1cd8d2; /* fallback for old browsers */
      background: -webkit-linear-gradient(to right, #93edc7, #1cd8d2); /* Chrome 10-25, Safari 5.1-6 */
      background: linear-gradient(to right, #93edc7, #1cd8d2); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    }
    &--vang {
      background: #f09819; /* fallback for old browsers */
      background: -webkit-linear-gradient(to right, #edde5d, #f09819); /* Chrome 10-25, Safari 5.1-6 */
      background: linear-gradient(to right, #edde5d, #f09819); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    }
  }
  &__icon {
    font-size: 40px;
    height: 80px;
    width: 80px;
    background-color: white;

    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__content {
    width: 70%;
    font-size: 30px;
    text-align: end;
  }
  &__money {
    font-size: 60px;
    font-weight: bold;
    // color: rgb(235, 235, 235);
  }
}
</style>
